/* src/app/rt-components/main-menu/main-menu.component.scss */
:host {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
:host .main-menu {
  max-width: 100%;
}
:host .main-menu > ul {
  list-style-type: none;
  margin: 0;
  padding: 22px 0;
}
:host .main-menu > ul .menu-item {
  position: relative;
}
:host .main-menu > ul .menu-item:after {
  background: #5dade0;
  bottom: 0;
  content: "";
  position: absolute;
  right: 100%;
  top: 0;
  transition: transform 0.2s ease-in-out;
  width: 4px;
}
.rtl :host .main-menu > ul .menu-item:after {
  left: 100%;
  right: auto;
}
:host .main-menu > ul .menu-item .item-link {
  color: rgba(17, 17, 17, 0.5);
  display: block;
  font-size: 1rem;
  font-weight: 400;
  padding: 11px 22px;
  position: relative;
  text-decoration: none;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
}
:host .main-menu > ul .menu-item .item-link .item-badge {
  background: rgba(17, 17, 17, 0.2);
  border-radius: 8px;
  color: #111111;
  float: right;
  font-size: 10px;
  line-height: 1;
  margin-top: 2px;
  padding: 2px 6px 4px;
}
.rtl :host .main-menu > ul .menu-item .item-link .item-badge {
  float: left;
}
:host .main-menu > ul .menu-item .item-link .icon {
  transition: color 0.2s ease-in-out;
  width: 22px;
}
:host .main-menu > ul .menu-item .item-link:hover {
  background: #bbbbbb;
  color: #ffffff;
}
:host .main-menu > ul .menu-item.menu-item-group:after {
  display: none;
}
:host .main-menu > ul .menu-item .group-title {
  color: rgba(0, 0, 0, 0.6);
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 22px 5px;
  text-transform: uppercase;
}
:host .main-menu > ul .menu-item .sub {
  list-style-type: none;
  overflow: hidden;
  margin: 0;
  max-height: 0;
  padding: 0;
  transition: max-height 0.1s ease-in-out;
}
:host .main-menu > ul .menu-item .sub .menu-item .item-link {
  padding: 5px 22px 6px 44px;
}
:host .main-menu > ul .menu-item .sub .menu-item:first-child > .item-link:before {
  border-top: 1px solid transparent;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: border 0.2s ease-in-out;
}
:host .main-menu > ul .menu-item:hover:after {
  transform: translateX(4px);
}
.rtl :host .main-menu > ul .menu-item:hover:after {
  transform: translateX(-4px);
}
:host .main-menu > ul .menu-item.active:after {
  transform: translateX(4px);
}
.rtl :host .main-menu > ul .menu-item.active:after {
  transform: translateX(-4px);
}
:host .main-menu > ul .menu-item.active > .item-link {
  color: #111111;
}
:host .main-menu > ul .menu-item.active > .item-link .icon {
  color: #5dade0;
}
:host .main-menu > ul .menu-item.has-sub {
  position: relative;
}
:host .main-menu > ul .menu-item.has-sub > .item-link {
  position: relative;
}
:host .main-menu > ul .menu-item.has-sub > .item-link .caret {
  margin-top: 0.55rem;
  position: absolute;
  right: 13px;
  top: 6px;
  transition: transform 0.1s ease-in-out;
}
.rtl :host .main-menu > ul .menu-item.has-sub > .item-link .caret {
  left: 13px;
  right: auto;
}
:host .main-menu > ul .menu-item.has-sub.active > .item-link .caret {
  transform: rotate(90deg);
}
:host .main-menu > ul .menu-item.has-sub.active > .sub {
  max-height: 1000px;
}
:host .main-menu > ul .menu-item.has-sub.active > .sub > .menu-item.active:first-child > .item-link:before {
  border-top-color: rgba(34, 34, 34, 0.1);
}
/*# sourceMappingURL=main-menu.component.css.map */
